export const IntermodalConst = {
  Reheating: 'reheating',
  EquipmentInterchangeReceipt: 'eir',
  Entry: 'entry',
  EntryIN: 'entry-in',
  EntryOUT: 'entry-out',
  Loading: 'loading',
  Lifts: 'Lifts',
  Weighbridge: 'weighbridge',
  Vessel: 'vessel',
  OnLoading: 'onloading',
  Cargo: 'Cargo',
  Dgd: 'Dgd',
};

export const WeighbridgeConst = {
  displayedColumns: [
    'ticket_no',
    'flow_id',
    'customer_name',
    'trucking_company_name',
    'container_no',
    'expected_date',
    'actual_date',
    'status',
    // 'type',
    'category',
    'action',
  ],
  entry: {
    header: {
      key_trans: 'Weighbridge Entry'
    }
  },
  exit: {
    header: {
      key_trans: 'Weighbridge Exit Ticket'
    }
  }
};

export const EquipmentInterchangeReceiptConst = {
  displayedColumns: [
    'receipt_no',
    'flow_id',
    'container_no',
    'customer',
    // 'delivered',
    'expected_date',
    'actual_date',
    'received',
    'status_name',
    'action',
  ],
  eirTabs: {
    direct: 'direct',
    indirect: 'indirect',
  },
  documentTypes: {
    receipt: 'Equipment Interchange Receipt.',
    additional_document: 'Additional documents.'
  }
};

export const BillOfLadingConst = {
  displayedColumns: [
    'bol_no',
    'flow_id',
    'shipper_name',
    'consignee_name',
    'expected_date',
    'actual_date',
    'status_name',
    'action',
  ],
  documentTypes: {
    report: 'Bill of Lading Report.',
    additional_document: 'Additional documents.'
  }
};

export const LoadingConst = {
  displayedColumns: [
    'flow_id',
    'customer',
    'vehicle_no',
    'tank_no',
    'order_no',
    'product_no',
    'expected_date',
    'actual_date',
    'expected_weight',
    'status_name',
    'action',
  ]
};

export const LoadUnloadConst = {
  displayedColumns: [
    'flow_id',
    'customer',
    'vehicle_no',
    'tank_no',
    'order_no',
    'product_no',
    'expected_date',
    'actual_date',
    'tare_weight',
    'type',
    'status_name',
    'action',
  ],
  liftOn: {
    header: {
      icon: 'lift-on-icon',
      key_trans: 'Lift On'
    },
    planActivities: [
      {
        name: 'Loading',
        value: 0,
        key_trans: 'loading'
      },
      {
        name: 'Heating/Cooling',
        value: 1,
        key_trans: 'heating_cooling'
      },
      {
        name: 'M&R',
        value: 2,
        key_trans: 'mr'
      },
      {
        name: 'Pickup Empty Clean',
        value: 3,
        key_trans: 'pickup_empty_clean'
      },
      {
        name: 'Pickup Empty Dirty',
        value: 4,
        key_trans: 'pickup_empty_dirty'
      },
      {
        name: 'Pickup',
        value: 5,
        key_trans: 'pickup_full'
      },
    ]
  },
  liftOff: {
    header: {
      icon: 'lift-off-icon',
      key_trans: 'Lift Off'
    },
    planActivities: [
      {
        name: 'Cleaning',
        value: 6,
        key_trans: 'cleaning'
      },
      {
        name: 'Storage Empty',
        value: 7,
        key_trans: 'storage_empty'
      },
      {
        name: 'Storage Full',
        value: 8,
        key_trans: 'storage_full'
      }
    ]
  }
};

export const ContainerConst = {
  displayedColumns: [
    'job_no',
    'flow_id',
    'customer_name',
    'container_no',
    'product_code',
    'desired_temp',
    'expected_start_date',
    // 'actual_start_date',
    'actual_end_date',
    'progress',
    'action',
  ],
};

export const CancelActions = [
  {
    name: 'Cancel & Continue Flow',
    value: 1,
    key_trans: 'continue_flow'
  },
  {
    name: 'Cancel & Stop Cargo',
    value: 2,
    key_trans: 'stop_container'
  },
  {
    name: 'Cancel & Create New Action',
    value: 3,
    key_trans: 'create_new_action'
  }
]
